import { render, staticRenderFns } from "./DeleteBulkContact.vue?vue&type=template&id=25ef1d37&"
import script from "./DeleteBulkContact.vue?vue&type=script&lang=js&"
export * from "./DeleteBulkContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports